import React, { Component } from 'react';
import { Route, Redirect, withRouter } from 'react-router-dom';
import AuthLayout from './pages/_layouts/auth';
import Main from './pages/_layouts/Main';
import { isAuthenticated } from './services/api';

export default function RouterWrapper({
    component: Component,
    isPrivate,
    ...rest
}) {
    if (!isAuthenticated() && isPrivate) {
        return (
            <Redirect
                to={{
                    pathname: '/login',
                }}
            />
        );
    }
    return <Route {...rest} render={props => <Component {...props} />} />;
}
